// Debounce: https://stackoverflow.com/questions/42199956/how-to-implement-debounce-in-vue2
function debounce(callback, wait = 2500) {
  let currentTimeout;
  return (...args) => {
    const context = this;
    clearTimeout(currentTimeout);
    currentTimeout = setTimeout(() => callback.apply(context, args), wait);
  };
}
